import styled from "@emotion/styled";

type ContainerProps = {
  $shouldShow: boolean;
};

export const Container = styled.div<ContainerProps>`
  display: ${props => (props.$shouldShow ? "flex" : "none")};
`;
